export default {
    // namespaced: true,
    state: {
        searchParams: {},
    },
    mutations: {
        search(state: any, value: any) {
            state.searchParams = value;
        },
    },
    actions: {},
}


